module.exports = __webpack_public_path__ + "img/oppo5.52a51fd6.png";